import styled from "styled-components";
import { ErrorScheme, Product, ProductScheme, UserScheme } from "client-v2";

import { Color, ColorV2, Text } from "@adoptaunabuelo/react-components";
import { useSelector } from "react-redux";
import { State } from "../../redux";
import { useState } from "react";
import SectionContainer from "../container/SectionContainer";

const Row = styled.div`
	display: flex;
	flex-direction: row;
`;
const CellSeparator = styled.div`
	display: flex;
	flex: 1;
	border-bottom: 1px dashed ${Color.line.soft};
	margin: 0px 8px 4px;
`;

const Ticket = (props: Props) => {
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const translation = useSelector(
		(state: State) => state.location.translation
	);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);

	const onNextClick = () => {
		if (props.product.price > 0) {
			props.onFinish({ data: 1 });
		} else {
			setLoading(true);
			Product.initRegister(props.product.objectId, {
				userId: props.user.objectId,
			})
				.then((result) => {
					setLoading(false);
					setSuccess(true);
				})
				.catch((error: ErrorScheme) => {
					setLoading(false);
					props.onFinish({ error: error.message });
				});
		}
	};

	return (
		<SectionContainer
			title="Resumen"
			childrenProps={{
				style: {
					marginTop: 16,
				},
			}}
			buttonProps={{
				children:
					props.product.price > 0 ? "Siguiente" : "Reservar ahora",
				loading: loading,
				success: success,
				onSuccess: () => props.onFinish({ data: 2 }),
				onClick: onNextClick,
			}}
		>
			<Text type="h6" style={{ fontFamily: "DM Mono", marginBottom: 32 }}>
				{props.product.title}
			</Text>
			<Row>
				<Text type="h6" style={{ fontFamily: "DM Mono" }}>
					Entrada general
				</Text>
				<CellSeparator />
				<Text type="h6" style={{ fontFamily: "DM Mono" }}>
					{props.product.price.toFixed(2)} €
				</Text>
			</Row>
			<Row style={{ marginTop: 8 }}>
				<Text type="h6" style={{ fontFamily: "DM Mono" }}>
					Impuestos
				</Text>
				<CellSeparator />
				<Text type="h6" style={{ fontFamily: "DM Mono" }}>
					0.00 €
				</Text>
			</Row>
			<Row style={{ marginTop: 18 }}>
				<Text
					type="h6"
					weight="medium"
					style={{ fontFamily: "DM Mono" }}
				>
					TOTAL
				</Text>
				<CellSeparator style={{ border: "none" }} />
				<Text
					type="h6"
					weight="medium"
					style={{ fontFamily: "DM Mono" }}
				>
					{props.product.price.toFixed(2) + " €"}
				</Text>
			</Row>
			<Text
				type="c1"
				style={{ color: ColorV2.text.neutralMedium, marginTop: 32 }}
			>
				Al reservar tu plaza, aceptas la{" "}
				<span
					style={{ textDecoration: "underline", cursor: "pointer" }}
					onClick={() =>
						window.open(
							"https://adoptaunabuelo.org/autorizacion-propia-imagen/",
							"_blank"
						)
					}
				>
					autorización para el uso de la propia imagen
				</span>
			</Text>
		</SectionContainer>
	);
};
export default Ticket;
export interface Props {
	product: ProductScheme;
	user: UserScheme;
	onFinish: (result: { data?: number; error?: string }) => void;
}
